export default function (nga, admin, menu) {
    var _ename = 'tracks';
    var _epretty = 'Tracks';
    var _entity = nga.entity(_ename);
    
    _entity.listView()
        .title(_epretty)
        .fields([
            nga.field('id').label('ID').isDetailLink(true),
            nga.field('code').label('Código'),
            nga.field('name').label('Nome'),
            nga.field('artist').label('Artista')
        ])
        .sortField('name')
        .sortDir('asc');
    
    _entity.creationView()
        .title('Create new ' + _epretty)
        .fields([
            nga.field('code')
                    .attributes({ placeholder: 'No space allowed, 5 chars min' })
                    .validation({ required: true })                    
                    .label('Código'),
            nga.field('duration', 'number')
                    .validation({ required: true })
                    .label('Duração (em segundos)'),
            nga.field('name')
                    .validation({ required: true })
                    .label('Nome'),
            nga.field('artist')
                    .validation({ required: true })
                    .label('Artista'),
            nga.field('isrc')
                    .validation({ required: true })
                    .label('ISRC'),
            nga.field('iswc')
                    .validation({ required: false })
                    .label('ISWC'),
            nga.field('cod_int_alb')
                    .validation({ required: true })
                    .label('COD_INT_ALB'),
            nga.field('tit_alb')
                    .validation({ required: true })
                    .label('TIT_ALB'),
            nga.field('authors')
                    .validation({ required: true })
                    .label('Autores'),
            nga.field('brand', 'reference')
                .attributes({ placeholder: 'Choose an option' })
                .targetEntity(nga.entity('tags'))
                .permanentFilters({ group: 'brand' })
                .targetField(nga.field('name'))
                .validation({ required: true })
                .label('Marca'),
            nga.field('language', 'reference')
                .attributes({ placeholder: 'Choose an option' })
                .targetEntity(nga.entity('tags'))
                .permanentFilters({ group: 'language' })
                .targetField(nga.field('name'))
                .validation({ required: true })
                .label('Idioma'),
            nga.field('style', 'reference')
                .attributes({ placeholder: 'Choose an option' })
                .targetEntity(nga.entity('tags'))
                .permanentFilters({ group: 'style' })
                .targetField(nga.field('name'))
                .validation({ required: true })
                .label('Estilo'),
            nga.field('type', 'reference')
                .attributes({ placeholder: 'Choose an option' })
                .targetEntity(nga.entity('tags'))
                .permanentFilters({ group: 'type' })
                .targetField(nga.field('name'))
                .validation({ required: true })
                .label('Tipo'),
            nga.field('format', 'reference_many')
                .attributes({ placeholder: 'Choose at least an option' })
                .targetEntity(nga.entity('tags'))
                .permanentFilters({ group: 'format' })
                .targetField(nga.field('name'))
                .validation({ required: true })
                .label('Formato'),
            nga.field('server', 'reference')
                .attributes({ placeholder: 'Choose an option' })
                .targetEntity(nga.entity('tags'))
                .permanentFilters({ group: 'server' })
                .targetField(nga.field('name'))
                .validation({ required: true })
                .label('Servidor'),
            nga.field('rights', 'reference_many')
                .attributes({ placeholder: 'Choose at least an option' })
                .targetEntity(nga.entity('productrights'))
                .targetField(nga.field('code'))
                .perPage(30000)
                .validation({ required: true })
                .label('Direitos'),
            nga.field('product_geoblocks', 'reference_many')
                .targetEntity(nga.entity('countries'))
                .perPage(30000)
                .targetField(nga.field('code'))
                .label('Geoblock'),
            nga.field('parents', 'reference_many')
                .targetEntity(nga.entity('products'))
                .perPage(30000)
                .permanentFilters({ types: ['pack', 'album'] })
                .targetField(nga.field('code'))
                .label('Albums / Packs')
        ]);

    admin.addEntity(_entity);
    
    menu.addChild(nga.menu(_entity).title(_epretty));
    
    return _entity;
}


// WEBPACK FOOTER //
// ./js/entities/track.js